import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "businesses" }
const _hoisted_2 = ["src"]

import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";
import {DEActivityStatusMap, EActivityStatus} from "@/model/activity";
import {QuestionCircleOutlined} from "@ant-design/icons-vue";
import {reactive} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FragmentOptions',
  setup(__props) {


const editor = useRoute().meta.editor as AEditor;
const model = reactive({font: {color: 'rgba(255,255,255,0.7)', fontSize: 28}, gap: [46, 46]})

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_watermark = _resolveComponent("a-watermark")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, { centered: "" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EActivityStatus), (status) => {
        return (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: status,
          tab: _unref(DEActivityStatusMap)[status]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editor).businesses[status].filter(b => _unref(editor).customBusinessRange[status].includes(b.meta.kind)), (b) => {
                return (_openBlock(), _createBlock(_component_a_card, {
                  bordered: "",
                  key: b
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_a_flex, { gap: "middle" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(b.icon))),
                        _createVNode(_component_a_flex, { vertical: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_typography_text, {
                              strong: "",
                              style: {"font-size":"16px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(b.title) + "  ", 1),
                                _createVNode(_component_a_tooltip, {
                                  title: b.description
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(QuestionCircleOutlined), { style: {"color":"gray"} })
                                  ]),
                                  _: 1
                                }, 8, ["title"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  extra: _withCtx(() => [
                    _createVNode(_component_a_switch, {
                      checked: b.meta.enabled,
                      "onUpdate:checked": ($event: any) => ((b.meta.enabled) = $event),
                      "un-checked-children": "关",
                      disabled: b.meta.lock,
                      "checked-children": "开",
                      onChange: ($event: any) => (_unref(editor).onBizChange(status,b.meta.kind,$event))
                    }, null, 8, ["checked", "onUpdate:checked", "disabled", "onChange"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_flex, {
                      vertical: "",
                      gap: "middle"
                    }, {
                      default: _withCtx(() => [
                        (b.preview)
                          ? (_openBlock(), _createBlock(_component_a_watermark, _mergeProps({
                              key: 0,
                              content: "效果图",
                              class: "water"
                            }, { ref_for: true }, model), {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: b.preview,
                                  alt: ""
                                }, null, 8, _hoisted_2)
                              ]),
                              _: 2
                            }, 1040))
                          : _createCommentVNode("", true),
                        (b.implementations(status).length>1)
                          ? (_openBlock(), _createBlock(_component_a_radio_group, {
                              key: 1,
                              value: b.meta.implementer,
                              "onUpdate:value": ($event: any) => ((b.meta.implementer) = $event),
                              options: b.implementations(status),
                              disabled: !b.meta.enabled,
                              onChange: ($event: any) => (_unref(editor).onImplementerChange(status,$event,b.meta))
                            }, null, 8, ["value", "onUpdate:value", "options", "disabled", "onChange"]))
                          : _createCommentVNode("", true),
                        (b.subs(status).length > 0)
                          ? (_openBlock(), _createBlock(_component_a_checkbox_group, {
                              key: 2,
                              value: b.meta.subs,
                              "onUpdate:value": ($event: any) => ((b.meta.subs) = $event),
                              options: b.subs(status),
                              onChange: ($event: any) => (_unref(editor).onBizSubChange(status,$event,b.meta)),
                              disabled: !b.meta.enabled,
                              style: {"width":"100%","flex-direction":"column","gap":"8px"}
                            }, null, 8, ["value", "onUpdate:value", "options", "onChange", "disabled"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]),
          _: 2
        }, 1032, ["tab"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})